import {
    focusElement,
    focusableElements,
    inertOutside,
    lockPage,
    setPanelVisibility,
    trapFocus,
    unlockPage,
} from '../navigation/shared';

class Modal {
    constructor() {
        this.activeModal = null;
        this.trigger = null;
        this.restoreInert = null;
        this.onOpen = () => { };
        this.onClose = () => { };
        this.init();
    }

    init() {
        document.querySelectorAll('[data-modal]').forEach((modal) => {
            if (!modal.classList.contains('is-active')) {
                modal.hidden = true;
                modal.inert = true;
                modal.setAttribute('aria-hidden', 'true');
            }
        });

        document.addEventListener('click', (event) => {
            const trigger = event.target.closest('[data-modal-target]');
            const close = event.target.closest('[data-modal-close]');

            if (trigger) {
                const targetId = trigger.getAttribute('data-modal-target');
                const modal = Array.from(document.querySelectorAll('[data-modal]')).find(
                    (candidate) => candidate.getAttribute('data-modal') === targetId
                );

                if (modal) {
                    event.preventDefault();
                    this.open(modal, trigger);
                }

                return;
            }

            if (close) {
                this.close(close.closest('[data-modal]'));
                return;
            }

            const modal = this.activeModal;
            const content = modal?.querySelector('[data-modal-content]');

            if (
                modal &&
                content &&
                modal.contains(event.target) &&
                !content.contains(event.target)
            ) {
                this.close(modal);
            }
        });

        document.addEventListener('keydown', (event) => {
            if (!this.activeModal) {
                return;
            }

            if (event.key === 'Escape') {
                event.preventDefault();
                this.close(this.activeModal);
            } else {
                trapFocus(event, this.activeModal);
            }
        });

        document.addEventListener('focusin', () => {
            if (this.activeModal && !this.activeModal.contains(document.activeElement)) {
                this.focusInitial(this.activeModal);
            }
        });
    }

    focusInitial(modal) {
        focusElement(
            modal.querySelector('[data-modal-autofocus]') ||
            modal.querySelector('input:not([type="hidden"])') ||
            focusableElements(modal)[0] ||
            modal
        );
    }

    open(modal, trigger = document.activeElement) {
        if (!modal || this.activeModal === modal) {
            return;
        }

        if (this.activeModal) {
            this.close(this.activeModal, { restoreFocus: false, immediate: true });
        }

        modal.dispatchEvent(new CustomEvent('modal:beforeopen', { bubbles: true }));
        this.trigger = trigger;
        this.activeModal = modal;
        modal.classList.add('is-active');
        modal.setAttribute('aria-modal', 'true');
        this.restoreInert = inertOutside(modal);
        lockPage(this);
        document.body.classList.add('modal-open');
        setPanelVisibility(modal, true, { distance: 0 });
        this.focusInitial(modal);

        if (typeof this.onOpen === 'function') {
            this.onOpen(modal);
        }

        modal.dispatchEvent(new CustomEvent('modal:open', { bubbles: true }));
    }

    close(modal, { restoreFocus = true, immediate = false } = {}) {
        if (!modal || this.activeModal !== modal) {
            return;
        }

        const trigger = this.trigger;
        this.activeModal = null;
        this.trigger = null;
        this.restoreInert?.();
        this.restoreInert = null;
        unlockPage(this);
        document.body.classList.remove('modal-open');
        modal.classList.remove('is-active');
        modal.removeAttribute('aria-modal');
        setPanelVisibility(modal, false, { immediate, distance: 0 });

        if (typeof this.onClose === 'function') {
            this.onClose(modal);
        }

        modal.dispatchEvent(new CustomEvent('modal:close', { bubbles: true }));

        if (restoreFocus && !focusElement(trigger)) {
            const header = document.querySelector('[data-module="header"]');
            focusElement(
                header?.querySelector('[data-modal-target="busca"]') ||
                header?.querySelector('[data-header-home]')
            );
        }
    }
}

export default new Modal();
